import { UserOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledMemberContainer = styled(FlexContainer)`
    margin-top: 16px;
    padding: 16px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    && {
        background-color: ${(props) => props.theme.secondaryBackgroundColor};
    }
`;

export const StyledMemberBadge = styled(Badge)<{ isWorking: boolean }>`
    .ant-badge-dot {
        top: 36px;
        left: 27px;
        height: 10px;
        width: 10px;

        background-color: ${({ isWorking, theme }) =>
            isWorking
                ? theme.successTypographyColor
                : theme.dangerTypographyColor};
    }
`;

export const StyledMemberLogo = styled(UserOutlined)`
    cursor: pointer;
    color: ${(props) => props.theme.primaryTypographyColor};
`;
